import { render, staticRenderFns } from "./ReplyTo.vue?vue&type=template&id=97bf3b20&scoped=true&"
import script from "./ReplyTo.vue?vue&type=script&lang=js&"
export * from "./ReplyTo.vue?vue&type=script&lang=js&"
import style0 from "./ReplyTo.vue?vue&type=style&index=0&id=97bf3b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bf3b20",
  null
  
)

export default component.exports